module.exports = __webpack_public_path__ + "static/img/15.719dd83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/15.png
// module id = Hztl
// module chunks = 0